/** Company-level status labels (the stored values stay "active" / "do_not_contact" / "not_a_fit" / "inactive"). */
export const COMPANY_STATUS_LABELS: Record<string, string> = {
  active: "Active", do_not_contact: "Do not Contact", not_a_fit: "Not a fit", inactive: "Inactive",
};

/** The two statuses a person sets with a reason (future RFPs only, reversible); do_not_contact is a separate opt-out. */
export type CompanySkipStatus = "not_a_fit" | "inactive";
export const isCompanySkipStatus = (status?: string | null): status is CompanySkipStatus => status === "not_a_fit" || status === "inactive";
